
import Header from '../../components/feature/Header';
import HeroSection from './components/HeroSection';
import ProductShowcase from './components/ProductShowcase';
import FeaturesSection from './components/FeaturesSection';
import ProjectLifecycleSection from './components/ProjectLifecycleSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/base/SEO';
import BackToTop from '../../components/base/BackToTop';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-['Montserrat']">
      <SEO
        title="MandaPost.com - Your Favorite Marketing Platform"
        description="#1 AI-powered social media marketing platform. Automate scheduling, content creation & analytics across Instagram, Facebook, LinkedIn, TikTok & more. Save 65% of your time. Free trial."
        keywords="social media marketing platform, social media management tool, social media scheduler, AI social media, content calendar, social media automation, Instagram scheduler, Facebook scheduler, LinkedIn scheduler, TikTok scheduler, social media analytics, content management, marketing automation"
        canonicalUrl="https://mandapost.com"
      />
      <Header />
      <HeroSection />
      <ProductShowcase />
      <FeaturesSection />
      <ProjectLifecycleSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
      <BackToTop />
    </div>
  );
}
